const LAST_REFRESH_KEY = 'last-refresh';
const MIN_RELOAD_INTERVAL_MS = 5 * 60 * 1000;

let reloading = false;

export function isChunkLoadError(error) {
  if (!error) return false;
  const msg = String(error.message || error || '').toLowerCase();
  const name = String(error.name || '').toLowerCase();
  return (
    name.includes('chunkloaderror') ||
    msg.includes('loading chunk') ||
    msg.includes('failed to fetch dynamically imported module') ||
    msg.includes('importing a module script failed') ||
    msg.includes('error loading dynamically imported module') ||
    msg.includes('unable to preload css') ||
    // CSS/asset fetch failures after deploy
    (msg.includes('failed to fetch') && msg.includes('/assets/'))
  );
}

/**
 * Reload the page to pick up a new deploy after a chunk failed to load.
 * Reloads at most once every 5 minutes so a chunk that is really missing
 * cannot cause a reload loop.
 *
 * @returns {boolean} true if a reload is in progress.
 */
export function reloadForStaleChunk() {
  if (reloading) return true;
  try {
    const last = Date.parse(
      window.localStorage.getItem(LAST_REFRESH_KEY) || ''
    );
    if (Date.now() - last < MIN_RELOAD_INTERVAL_MS) return false;
    window.localStorage.setItem(LAST_REFRESH_KEY, new Date().toISOString());
  } catch {
    // Without storage the guard can't persist across reloads, so don't risk a loop.
    return false;
  }
  reloading = true;
  window.location.reload();
  return true;
}

/**
 * Vite fires `vite:preloadError` when any dynamic import (or its CSS) fails,
 * including imports outside of route-level `lazy()`.
 */
export function installStaleChunkReload() {
  window.addEventListener('vite:preloadError', (event) => {
    if (isChunkLoadError(event.payload)) {
      reloadForStaleChunk();
    }
  });
}
